// duplicated in embed.js, remember to update both
export const EMBED_WIDTH = 350; // in pixels
export const EMBED_HEIGHT = 370; // in pixels
export const US_MAP_EMBED_WIDTH = 400; // in pixels;
export const US_MAP_EMBED_HEIGHT = 440; // in pixels;
